import { Card, CardBody, Col, Row } from 'reactstrap'
import { SmallProgressBars } from '../../../../Utils/Constants'
import { smallProgressData, smallProgressList } from '../../../../Data/Ui-Kits/Progress/Progress'
import CardHeaderCommon from '../../../../Utils/CommonComponents/CardHeaderCommon'
import { ProgressBar } from '../../../../AbstractElements'

const SmallProgressBarsCart = () => {
  return (
    <Col xl="6">
      <Card className="height-equal">
        <CardHeaderCommon title={SmallProgressBars} span={smallProgressData} />
        <CardBody className="progress-showcase progress-b-space">
          <Row>
            <Col>
              <ProgressBar color="primary" animated striped bar value="30" max={100} className="small-progressbar rounded-pill sm-progress-bar overflow-visible mt-4">
                <span className="txt-primary progress-label">30 MB Data</span>
                <span className="animate-circle"></span>
              </ProgressBar>
              {smallProgressList.map(({ value, title }, index) => (
                <ProgressBar color="primary" animated striped bar value={value} className="small-progressbar rounded-pill sm-progress-bar overflow-visible mt-4" key={index}>
                  <span className="txt-primary progress-label">{title}</span>
                  <span className="animate-circle"></span>
                </ProgressBar>
              ))}
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  )
}

export default SmallProgressBarsCart